import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, UntypedFormGroup, ValidatorFn, AbstractControl } from '@angular/forms';
import { InventoryService } from '../../services/inventory.service'
import { GlobalSearchService } from '../../services/globalsearchservice.service'
import { SUPER_ADMIN_LEVEL, userLevelAtLeast } from '../../constants/access-levels'
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-gl-classes',
	templateUrl: './gl-classes.component.html',
	styleUrls: ['./gl-classes.component.scss']
})
export class GlClassesComponent implements OnInit {

	searchingglclass: any[] = [];
	@ViewChild('glEdit') glEditRef: ElementRef;
	@ViewChild('glc') glcRef: ElementRef;

	filteredglclass: any = [];
	glclasses: any = [];
	glclasssearch = new FormControl('');
	glClassForm: UntypedFormGroup;
	viewingglc: any = false;
	config: any = null;
	user: any = null;

	constructor(private fb: UntypedFormBuilder, private inventoryService: InventoryService, private globalSearchService: GlobalSearchService, private modalService: NgbModal) {}

	/** Clevehill setups: add / edit / remove GL classes require full admin. */
	get canManageGlClasses(): boolean {
		const c = this.config?.env?.client;
		const clevehill = c === 'clevehill' || c === 'clevehill-ha';
		if (!clevehill) return true;
		return userLevelAtLeast(this.user, SUPER_ADMIN_LEVEL);
	}

	ngOnInit(): void {
		this.globalSearchService.configsubscription.subscribe((r) => {
			this.config = r;
		});
		this.globalSearchService.user.subscribe((u) => {
			this.user = u;
		});

		this.glclasssearch.valueChanges.subscribe(newValue => {
			this.filterGLclass();
		});
		this.loadGLClasses();
	}

	filterGLclass() {

		if (this.glclasssearch.value == '') {
			this.searchingglclass = this.glclasses ?? [];
		} else {
			this.searchingglclass = this.globalSearchService.filterItem(this.glclasses ?? [], this.glclasssearch.value, 'code,description') ?? [];
		}

	}

	addGLClass() {

		this.glClassForm = this.fb.group({
			code: ['', Validators.required],
			name: ['', Validators.required],
		});
		this.modalService.open(this.glEditRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});

	}
	saveGLClass() {
		if (this.glClassForm.valid) {
			this.glClassForm.get('code').enable()
			this.inventoryService.saveGLClass(this.glClassForm.value).subscribe(result => {
				this.loadGLClasses();
				this.modalService.dismissAll();
			})
		}
	}
	loadGLClasses() {
		this.inventoryService.getGLClasses().subscribe(results => {
			this.glclasses = results ?? [];
			this.filteredglclass = this.glclasses;
			this.searchingglclass = this.glclasses;
		});
	}
	editGLC(glc: any) {
		this.glClassForm = this.fb.group({
			code: [glc.code],
			name: [glc.name, Validators.required],
		});

		this.glClassForm.get('code').disable();
		this.modalService.open(this.glEditRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});

	}
	removeGLC(glc: any) {
		this.inventoryService.removeGLClass(glc).subscribe((result: any) => {
			if (result.success) {
				this.loadGLClasses();
				this.modalService.dismissAll();
			} else {
				alert(result.message);
			}
		})
	}
	viewProducts(glc: any) {
		this.viewingglc = glc;

		this.modalService.open(this.glcRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});
	}
}
